import { useInfiniteQuery } from '@tanstack/react-query';
import { repo } from 'index';
import flapMap from 'lodash/fp/flatMap';

const INITIAL_PAGE_PARAM = 1;

export const useInfiniteCoupons = ({ state, perPage }, options = {}) => {
  const {
    data,
    fetchNextPage,
    fetchPreviousPage,
    fetchStatus,
    hasNextPage,
    hasPreviousPage,
    isFetchingNextPage,
    isFetchingPreviousPage,
    status: getCouponsStatus,
    error: getCouponsError,
  } = useInfiniteQuery({
    queryKey: ['coupons', JSON.stringify(state), perPage],
    queryFn: ({ pageParam }) =>
      repo.fetchCoupons({
        perPage,
        page: pageParam,
        state,
      }),
    initialPageParam: INITIAL_PAGE_PARAM,
    getPreviousPageParam: firstPage => {
      const currentPage = firstPage.data.paging.current_page;
      const prevPage = currentPage - 1;
      return prevPage > 0 ? prevPage : undefined;
    },
    getNextPageParam: lastPage => {
      const currentPage = lastPage.data.paging.current_page;
      const totalPages = lastPage.data.paging.total_page;
      const nextPage = currentPage + 1;
      return nextPage <= totalPages ? nextPage : undefined;
    },
    ...options,
  });

  const pages = data?.pages ?? [];

  const coupons = flapMap(page => [...page.data.data], pages);

  return {
    coupons,
    getCouponsStatus,
    getCouponsError,
    hasCouponsNextPage: hasNextPage,
    hasCouponsPreviousPage: hasPreviousPage,
    isFetchingCouponsNextPage: isFetchingNextPage,
    isFetchingCouponsPreviousPage: isFetchingPreviousPage,
    fetchCouponsNextPage: fetchNextPage,
    fetchCouponsPreviousPage: fetchPreviousPage,
    fetchInfiniteCouponStatus: fetchStatus,
  };
};
